export class FileTransferModel{
  fileName:string;
  fileDataBase64:string;
  fileDataByte:string;
  content:string;
  contentType:string;
}